export default __webpack_public_path__ + "static/media/cb_1.d30e819f.png";